module.exports = __webpack_public_path__ + "img/right-3.60588a23.jpg";